import React, { useEffect } from 'react'

import { Col, Row, Skeleton } from 'antd'

import getBenefitDetails, { BenefitDetails } from 'core/application/csiDashboard/csiSearch/getBenefitDetails'
import getPerksProgramDetails, {
  PerksProgramGeneralDetails,
} from 'core/application/csiDashboard/csiSearch/perks/getPerksProgramDetails'

import useQueryRequest from 'common/hooks/useQueryRequest'

import CsiPerksBenefitDetails from './benefitDetails'
import PerksGeneralDetails from './generalDetails'

interface PerksProgramDetailsProps {
  companyId: string
  planPeriodId: string
}

const PerksProgramDetails: React.FC<PerksProgramDetailsProps> = (props) => {
  const [perksGeneralDetails, isLoading] = useQueryRequest<PerksProgramGeneralDetails | null>(null, () =>
    getPerksProgramDetails(props.companyId ?? '', props.planPeriodId),
  )

  const [benefitDetails, isbenefitDetailsLoading, sendGetBenefitDetails] = useQueryRequest<BenefitDetails | null>(null)
  const handleGetBenefitDetails = async () => {
    await sendGetBenefitDetails(() => getBenefitDetails(props.planPeriodId))
  }

  useEffect(() => {
    ;(async () => {
      await handleGetBenefitDetails()
    })()
  }, [])

  return (
    <Skeleton active={true} loading={isLoading}>
      <Row>
        <Col md={24}>
          {perksGeneralDetails && benefitDetails && <PerksGeneralDetails generalDetails={perksGeneralDetails} />}
        </Col>
      </Row>
      <Row>
        <Col md={24} className="mt-32">
          {perksGeneralDetails && benefitDetails && (
            <CsiPerksBenefitDetails
              planPeriodId={props.planPeriodId}
              benefitDetails={benefitDetails}
              refreshBenefitDetails={handleGetBenefitDetails}
            />
          )}
        </Col>
      </Row>
    </Skeleton>
  )
}

export default PerksProgramDetails
